import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService, LoginService } from '@core';

import { AuthRedirectService } from '@core/authentication/auth-redirect.service';

@Component({
  selector: 'app-sso-handler',
  template: '',
  standalone: true,
  imports: [],
})
export class SSOHandlerComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private loginService: LoginService,
    private authRedirectService: AuthRedirectService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const { token, username } = this.retrieveParams(params);

      if (token && username) {
        this.authService.setToken(token, username);

        this.loginService.me(username).subscribe(user => {
          this.authService.setUser(user);
          this.router.navigateByUrl(this.authRedirectService.consume() || '/');
        });
      } else {
        this.router.navigateByUrl('/auth/login');
      }
    });
  }

  private retrieveParams(params: any) {
    let token: string | undefined = undefined;
    try {
      token = JSON.parse(params.token).access_token;
    } catch {
      /* ignore invalid token JSON */
    }

    return {
      token,
      username: params.username,
    };
  }
}
